(ns com.theplantscape.web-ui.svg.helpers
  (:require
   #_[com.theplantscape.svg-generation.diagram :refer [ui-svg-diagram]]
   [com.theplantscape.svg-generation.ensemble :refer [rkey transform-origin]]
   #_[com.theplantscape.web-ui.svg.canvas 
    :refer [ui-svg-diagram]]
   [com.theplantscape.browser-utils.ensemble :as h]
   [reagent.dom.server :refer [render-to-string]]))

#_(defn add-pointer-events
    ([m] (add-pointer-events nil nil m))
    ([root-svg-element transformed-svg-element m] (add-pointer-events nil nil m)
                                                  (prn "pointer event" root-svg-element)
                                                  (prn "pointer event" m)
                                                  (merge m
                                                         {:on-pointer-move (partial touch-move root-svg-element transformed-svg-element)
                                                          :on-pointer-up touch-end
                                                          :on-pointer-cancel reset-pointer
                                                          :on-pointer-down touch-start})))

(defn ui-svg-root
  ([id] (ui-svg-root id {}))
  ([id extend]
   [:svg (merge
          {:xmlns "http://www.w3.org/2000/svg"
           :version "1.1"
           :id id
           :style  (transform-origin {} "50% 50%")
           :width "100%" :height "100%"}
          extend)]))

(defn ui-svg
  ([id body] (ui-svg id body {}))
  ([id body extend]
   [:svg (merge
          {:xmlns "http://www.w3.org/2000/svg"
           :version "1.1"
           :id id
           :style  (transform-origin {} "50% 50%")
           :width "100%" :height "100%"}
          extend)
    body]))

(defn export-svg [svg]
  (h/download-data-url "test.svg" (h/data-uri-svg (render-to-string [ui-svg "export" svg]))))
